import React, {useEffect, useState} from 'react';
import {I18n} from 'react-redux-i18n';

import {IconButton, InputAdornment, withStyles, WithStyles} from '@material-ui/core';
import {Close} from '@material-ui/icons';

import {CustomButton, CustomInput} from '../../material-dashboard-pro-react/components';

import style from './style';

type SearchWithButtonsProps = WithStyles<typeof style> & {
  // eslint-disable-next-line no-unused-vars
  onSubmit: (v: string) => void;
  // eslint-disable-next-line no-unused-vars
  onReset: (manual: boolean) => void;
  doReset?: boolean;
  placeholder?: string;
  disabled?: boolean;

  customContainerClasses?: string;
  customInputClasses?: string;
};

/**
 * Component with search input and 'submit' and 'reset' buttons
 * @param onSubmit - callback function for submit. Passes filter value as param
 * @param onReset - callback function for reset. Passes boolean `manual`
 * if it's true, than reset was called by manual user action (e.g. button press)
 * @param placeholder - placeholder for input
 * @param doReset - if true is passed, value will be reset
 * @param disabled - if true, component will be disabled
 * @param customContainerClasses - custom classes for main container
 * @param customInputClasses - custom classes for input
 */
function SearchWithButtons({
  classes,
  onSubmit,
  onReset,
  doReset = false,
  placeholder = '',
  disabled = false,
  customContainerClasses = '',
  customInputClasses = '',
}: SearchWithButtonsProps) {
  const [searchValue, setSearchValue] = useState('');

  const reset = (manual = true) => {
    setSearchValue('');
    onReset(manual);
  };

  useEffect(() => {
    if (doReset) {
      reset(false);
    }
  }, [doReset]);

  return (
    <div className={`${classes.container} ${customContainerClasses}`}>
      <CustomInput
        name="groupsSearch"
        inputProps={{
          value: searchValue,
          disabled,
          onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
            setSearchValue(e.target.value),
          onKeyPress: (e: React.KeyboardEvent<HTMLInputElement>) => {
            if (e.key === 'Enter') {
              onSubmit(searchValue);
            }
          },
          placeholder,
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={() => setSearchValue('')}>
                <Close />
              </IconButton>
            </InputAdornment>
          ),
        }}
        formControlProps={{
          className: `${classes.input} ${customInputClasses}`,
        }}
      />
      <div className={classes.container__buttons}>
        <CustomButton
          type="submit"
          color="secondary"
          disabled={disabled}
          onClick={() => onSubmit(searchValue)}
          size="sm"
        >
          {I18n.t('buttons.submit').toUpperCase()}
        </CustomButton>
        <CustomButton
          color="gray"
          disabled={disabled}
          onClick={reset}
          size="sm"
        >
          {I18n.t('buttons.reset').toUpperCase()}
        </CustomButton>
      </div>
    </div>
  );
}

export default withStyles(style)(SearchWithButtons);
